import React from 'react'
import AccordionHandler from './AccordionHandler'
import Panel from '../Panel'

const Accordion = ({ children, ...props }) => (
  <Panel noMargin mediumPadding lineBorder noShadow flex={1} {...props}>
    <AccordionHandler {...props}>{children}</AccordionHandler>
  </Panel>
)

export default Accordion
